import { Slide } from "@mui/material";
import { forwardRef } from "react";
import { routes } from "../../options/routes";
import { getPDF } from "../../api";

export const Transition = forwardRef(function Transition(props, ref)
{
    return <Slide direction="up" ref={ref} {...props} />;
});

export const generateStatsPdf = async (player, isDownloadingState) =>
{
    let date = formatDate(new Date()),
        filename = `${player.rezzilId}-${player.firstname}-${player.lastname}-${date}.pdf`,
        token = JSON.parse(localStorage.getItem("token"));

    let data = {
        id: player.rezzilId,
        token
    };
    //  window.open(url, "_blank");
    isDownloadingState(true)
    getPDF(
        data,
        { name: filename },
        () =>
        {
            isDownloadingState(false);
        }
    );
}

export const redirectStatsPage = async (player) =>
{
    let url = routes.indexPrintStats + "/" + player.rezzilId;
    window.open(url, "_blank");

}

export const formatDate = (date) =>
{
    let dateObj = new Date();
    if (typeof date == 'object')
    {
        dateObj = date;
    }
    if (typeof date == 'string')
    {
        dateObj = new Date(date);
    }
    return dateObj.toLocaleDateString(
        'en-gb'
    ).replace(/\//g, '.');
}